import { render, staticRenderFns } from "./MissionIcon.vue?vue&type=template&id=147d1208&scoped=true&"
import script from "./MissionIcon.vue?vue&type=script&lang=ts&"
export * from "./MissionIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147d1208",
  null
  
)

export default component.exports